import React, { Component } from "react";
import { Confirm, withDataProvider, showNotification } from "react-admin";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

class PNRDetailsButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  async getPNRinfos() {
    const { dataProvider, record } = this.props;
    const { data } = await dataProvider("PNR_DATA", "", { pnrRef: record });
    this.setState({ pnrData: JSON.stringify(data, null, 4) });
  }

  handleDialogClose = () => {
    this.setState({ isOpen: false });
  };

  handleClick = () => {
    this.setState({ isOpen: true });
    this.getPNRinfos();
  };

  render() {
    return (
      <>
        <Button variant="contained" color="primary" onClick={this.handleClick}>
          afficher les données PNR du ticket
        </Button>
        <Dialog
          open={this.state.isOpen}
          maxWidth="lg"
          onClose={this.handleDialogClose}
          aria-labelledby="draggable-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Informations sur le PNR
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <pre>{this.state.pnrData}</pre>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleDialogClose}
              variant="contained"
              color="secondary"
            >
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withDataProvider(PNRDetailsButton);
